// app/src/lib/settings.js — the SETTINGS-THREAD chip system for Length + Language (the Aspect
// chip lives in aspect.js). The chips cycle through presets; the ENGINE resolves the canonical
// values (chip > prompt-parse > default) and the 20-minute clamp, so these are just the UI dials.

// preset lengths the Length chip cycles through (15s → 20 min, the hard cap). A resolved value
// that isn't a preset (e.g. "10 mins" parsed from the prompt) still displays fine; cycling nudges
// to the next preset above it.
export const LENGTHS = [15, 30, 45, 60, 90, 120, 180, 300, 600, 900, 1200];

export function nextLength(cur) {
  const c = Number(cur) || 30;
  return LENGTHS.find((n) => n > c) || LENGTHS[0];
}

export function fmtLength(sec) {
  const s = Math.max(0, Math.round(Number(sec) || 0));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60), r = s % 60;
  return r ? `${m}m ${r}s` : `${m} min`;
}

// the video LANGUAGE (distinct from the UI locale). Names are endonyms (shown in their own
// script) — the standard, idiomatic convention for a language picker.
export const LANGUAGES = [
  { tag: 'en-US', name: 'English' },
  { tag: 'zh-CN', name: '中文' },
  { tag: 'es-ES', name: 'Español' },
  { tag: 'ms-MY', name: 'Bahasa Melayu' },
  { tag: 'id-ID', name: 'Bahasa Indonesia' },
  { tag: 'ja-JP', name: '日本語' },
  { tag: 'ko-KR', name: '한국어' },
  { tag: 'fr-FR', name: 'Français' },
  { tag: 'th-TH', name: 'ไทย' },
];

const primary = (tag) => String(tag || '').split('-')[0].toLowerCase();

export function langName(tag) {
  const l = LANGUAGES.find((x) => x.tag === tag) || LANGUAGES.find((x) => primary(x.tag) === primary(tag));
  return l ? l.name : (tag || 'English');
}

export function nextLanguage(tag) {
  const i = LANGUAGES.findIndex((x) => x.tag === tag || primary(x.tag) === primary(tag));
  return LANGUAGES[(i + 1) % LANGUAGES.length].tag;
}

// the three settings the app reads off a draft/set, preferring an explicit draft chip, then the
// engine-resolved value on the set, then the default. `assumed` flags which came from a default.
export function effectiveSettings(draftSettings, resolved) {
  const d = draftSettings || {};
  const r = resolved || {};
  const length_s = (d.length_s != null ? Number(d.length_s) : null) || r.length_s || 30;
  const aspect = d.aspect || r.aspect || '9:16';
  const language = d.language || r.language || 'en-US';
  const assumed = r.assumed || {};
  return {
    length_s, aspect, language,
    // a value is "assumed" only when the user hasn't set a chip for it AND the engine defaulted it
    assumed: {
      length: d.length_s == null && !!assumed.length,
      aspect: !d.aspect && !!assumed.aspect,
      language: !d.language && !!assumed.language,
    },
  };
}
